import request from '@/utils/request'

let FileApi = {

    /*文件类别列表*/
    fileCategory(data, errorback) {
        return request._post('/shop/file.file/category', data, errorback);
    },

    /*文件列表*/
    fileList(data, errorback) {
        return request._post('/shop/file.file/lists', data, errorback);
    },

    /*删除多文件*/
    deleteFiles(data, errorback) {
        return request._post('/shop/file.file/deleteFiles', data, errorback);
    },

    /*添加文件分类*/
    addCategory(data, errorback) {
        return request._post('/shop/file.file/addGroup', data, errorback);
    },

    /*修改文件分类*/
    editCategory(data, errorback) {
        return request._post('/shop/file.file/editGroup', data, errorback);
    },

    /*删除文件分类*/
    deleteCategory(data, errorback) {
        return request._post('/shop/file.file/deleteGroup', data, errorback);
    },

    /*上传：图片/视频/文件统一入口
     * - formData 内需包含 file_type: image | video | document | app_package
     * - image/video 仍走原图片/视频上传逻辑
     * - document 走 pdf/word/ppt 等通用文件上传（后端按 file_type 做校验）
     * - app_package 走 apk/wgt 安装包上传（升级管理用）
     */
    uploadFile(formData, errorback) {
        const fileType = formData.get('file_type') || 'image';
        // 仍复用同一个上传地址，由后端根据 file_type 决定校验场景
        return request._upload('/shop/file.upload/image', formData, errorback);
    },
    /*移动文件*/
    moveFile(formData, errorback) {
        return request._upload('/shop/file.upload/moveFiles', formData, errorback);
    },


}

export default FileApi;



// WEBPACK FOOTER //
// ./src/api/file.js